import { useQuery } from "@tanstack/react-query";
import { request } from "../../utilities/axios-utils";
import useSharedData from "../useSharedData.ts";

export const convertQuoteAndGetAuraSession = async (
	accessToken,
	openErrorModal
) => {
	try {
		let returnResponse = {};
		const auraResponse = await request({
			url: "/convertQuote",
			method: "PUT",
			data: null,
			accessToken: accessToken,
		});
		if (200 === auraResponse.status) {
			returnResponse = auraResponse.data;
			return returnResponse;
		} else {
			openErrorModal();
			throw auraResponse;
		}
	} catch (error) {
		console.error(
			"Error while converting quote and creating UW session :",
			error
		);
	}
};

export const useGetAuraInterviewSession = (accessToken) => {
	const { openErrorModal } = useSharedData();
	return useQuery({
		queryKey: ["auraInterviewSession"],
		queryFn: () => convertQuoteAndGetAuraSession(accessToken, openErrorModal),
		refetchOnWindowFocus: false,
	});
};
